import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Handshake, Loader2, ArrowRight, BadgeCheck, Building2 } from "lucide-react";

export default function CooperativeConvenzionate() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/public/cooperative-convenzionate").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  const vai = (c) => navigate(c.link || `/rete-solidale?c=${encodeURIComponent(c.codice)}`);

  return (
    <div className="min-h-screen bg-bone px-4 py-10" data-testid="cooperative-convenzionate-page">
      <div className="mx-auto w-full max-w-5xl space-y-8">
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-terracotta">
            <Handshake className="h-5 w-5" />
            <span className="text-sm font-semibold uppercase tracking-wide">Rete Solidale Assietica</span>
          </div>
          <h1 className="font-heading text-4xl font-semibold leading-tight text-forest sm:text-5xl">Accordi e Convenzioni</h1>
          <p className="max-w-2xl text-base text-muted-foreground">
            Trova la tua cooperativa e accedi alle soluzioni assicurative dedicate ai suoi soci, lavoratori e volontari.
            Seleziona il tuo ente: ti porteremo al percorso Rete Solidale già impostato sulla tua convenzione, dove potrai
            richiedere la tua proposta personale.
          </p>
        </div>

        {items === null ? (
          <div className="flex h-48 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-forest" /></div>
        ) : items.length === 0 ? (
          <Card className="rounded-2xl border-border/60 p-10 text-center" data-testid="cc-empty">
            <Building2 className="mx-auto mb-3 h-10 w-10 text-forest/40" />
            <p className="text-muted-foreground">Al momento non ci sono cooperative convenzionate pubblicate. Torna a trovarci presto.</p>
          </Card>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((c) => (
              <button
                key={c.id}
                data-testid={`cc-card-${c.id}`}
                onClick={() => vai(c)}
                className="group flex flex-col items-start gap-4 rounded-2xl border border-border/60 bg-white p-5 text-left transition-all hover:-translate-y-0.5 hover:border-forest/40 hover:shadow-lg"
              >
                {/* Area logo riservata (per ora vuota) */}
                <div className="flex h-16 w-full items-center justify-center rounded-xl border border-dashed border-border/60 bg-sage/20 text-forest/30" aria-hidden="true">
                  {c.logo_url ? (
                    <img src={c.logo_url} alt={c.cooperativa_nome} className="max-h-14 max-w-full object-contain" />
                  ) : (
                    <Building2 className="h-7 w-7" />
                  )}
                </div>
                <div className="flex-1">
                  <h2 className="font-heading text-lg font-semibold text-forest">{c.cooperativa_nome}</h2>
                  {c.mondo_conf && (
                    <span className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-forest/10 px-2.5 py-0.5 text-xs font-medium text-forest" data-testid={`cc-conf-${c.id}`}>
                      <BadgeCheck className="h-3.5 w-3.5" /> Confcooperative
                    </span>
                  )}
                </div>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-terracotta">
                  Accedi alle convenzioni <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </button>
            ))}
          </div>
        )}

        <p className="border-t border-border/60 pt-6 text-xs text-muted-foreground">
          Il sito presenta la convenzione, il portale genera il preventivo. L'appartenenza alla cooperativa è
          autodichiarata e verificata prima dell'emissione. Nessun prezzo o sconto è mostrato in questa pagina.
        </p>
      </div>
    </div>
  );
}
